import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import CastingCommon from '@utils/casting-common';

import Influencers from '@project/common/influencers';
import CheckDrafts from '@project/common/check-drafts';
// -------------------------------------------------------

class Tasks extends React.Component {
  render() {
    let base = this.props.data;
    
    return (
      <div className="project-tasks">
        <div className="task-contents">
          
          {/*<h1>確認が必要なインフルエンサーが<span>{this.props.alert_count}</span>件あります</h1>*/}
          
          <div className="tasks-progress-box">
            <TasksProgressAction base={base} mode="client_check" title="クライアントチェック" />
            
            <TasksProgressAction base={base} mode="assign_action" title="アサインアクション" />
            
            <TasksProgressAction base={base} mode="draft_action" title="下書き依頼" />
            
            <DraftProgressAction base={base} mode="assign_action" title="下書き確認" />
            
            <TasksProgressAction base={base} mode="report_select" title="投稿の選択" />
          </div>
          
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

class TasksProgressAction extends React.Component {
  
  /*bulkClientCheck(targets) {
    let chk = confirm('まとめてクライアントにチェックの依頼をします。よろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/workflow/bulk_client_check', { project_id: this.props.base.project.id, targets: targets },
      function(res){
        
        alert('まとめてチェックを依頼しました！');
        this.props.base.event.updateData('workflow', res.body.workflow);
        
      }.bind(this)
    );
  }*/
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    let mode = this.props.mode;
    let influencers = base.workflow.influencers;
    
    let targets = [];
    for( let insta_user_id in influencers ){
      let request_action = CastingCommon.getRequestAction(base, insta_user_id);
      if( request_action == mode ) targets.push(insta_user_id);
    }
    //if( targets.length == 0 ) return null;
    
    let target_count = targets.length;
    if( target_count > 100 ) target_count = 99;
    
    return (
      <div className={'tasks-progress-action count_'+ target_count}>
        <div className="title">{this.props.title}{(target_count > 0) && <span>{target_count}</span>}</div>
        
        <Influencers base={base} targets={targets} side_tab="action" />
        
        { ( target_count > 1 && mode == 'client_check') && <p className="bulk-button" onClick={base.event.showClientCheckModal.bind(this, targets)}>まとめて操作</p> }
        { ( target_count > 1 && mode == 'assign_action') && <p className="bulk-button" onClick={base.event.showAssignModal.bind(this, this.props.base.project.id, targets)}>まとめて操作</p> }
        { ( target_count > 1 && mode == 'draft_action') && <p className="bulk-button" onClick={base.event.showDraftModal.bind(this, targets)}>まとめて操作</p> }
        
      </div>
    );
  }
}
// -------------------------------------------------------

class DraftProgressAction extends React.Component {
  render() {
    let base = this.props.base;
    if( base.check_draft.length == 0 && base.all_draft_count == 0 ) return null;
    
    let target_count = base.check_draft.length;
    if( target_count > 100 ) target_count = 99;
    
    return (
      <div className="tasks-progress-action">
        <div className="title">{this.props.title}{(target_count > 0) && <span>{target_count}</span>}</div>
        
        <div className="all-button" onClick={base.event.showDraftListModal.bind(this, base.project.id)}>すべて表示 ({base.all_draft_count})</div>
        
        <CheckDrafts base={base} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Tasks;